import * as React from "react";
import "./ResponsiveAppBar.css";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import Avatar from "@mui/material/Avatar";
import { NavLink } from "react-router-dom";

const profilePic = require("./headshot.jpg");

const pages = ["About", "Portfolio"];

function ResponsiveAppBar(props) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        background: "var(--secondary)",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {!props.mobile && (
            <Button href="/">
              <Avatar
                alt="Ellen Saylor"
                src={profilePic}
                sx={{ marginRight: "10px" }}
              />
            </Button>
          )}
          <Typography
            href="/"
            variant="h6"
            noWrap
            component="a"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontWeight: 100,
              letterSpacing: ".3rem",
              color: "black",
              textDecoration: "none",
            }}
          >
            Ellen Saylor
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="black"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <NavLink
                  key={page}
                  to={page}
                  className={({ isActive }) =>
                    isActive & !props.mobile ? "active" : ""
                  }
                >
                  <MenuItem onClick={handleCloseNavMenu}>{page}</MenuItem>
                </NavLink>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontWeight: 100,
              letterSpacing: ".3rem",
              color: "black",
              textDecoration: "none",
            }}
          >
            ES
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, display: "block" }}
                disableRipple
              >
                <NavLink
                  to={page}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {page}
                </NavLink>
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="LinkedIn">
              <IconButton
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/in/ellensaylor/",
                    "_blank"
                  )
                }
                sx={{ p: 1 }}
              >
                <LinkedInIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Github">
              <IconButton
                onClick={() =>
                  window.open("https://github.com/ellensaylor8", "_blank")
                }
                sx={{ p: 1 }}
              >
                <GitHubIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
